import { webVersion } from '@/util/headMetaTags';
import { logger } from '@/util';
import { client } from '@/api/http';
import { type AxiosResponse, HttpStatusCode } from 'axios';

const log = logger('DownloadFromLink');

export interface DownloadLinkObject {
    link: string;
}

export async function downloadFromPresignedLink(url: string): Promise<void> {
    // Make request to the API to get the presigned download link and open it in a new window tab
    client.get(url).then(({ status, data }: AxiosResponse<DownloadLinkObject>) => {
        if (status === HttpStatusCode.Ok) {
            const link = data.link;
            if (webVersion() === 'DEV') {
                log.info(
                    'Downloading link from local development environment. ' +
                        'No file will be downloaded, opening new window tab to verify local file path.',
                );
            }
            const popup = window.open(link, '_blank');
            if (!popup) {
                log.error(
                    'Failed to open download link in a new window/tab. This may be due to a popup blocker.',
                );
            }
        } else {
            throw Error(`Failed to get download link from url: ${url}`);
        }
    });
}
